import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'h3-feedback-pane',
  templateUrl: './feedback-pane.component.html',
  styleUrls: ['./feedback-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, NgIf, MatIconButton],
})
export class FeedbackPaneComponent {
  @Input() closeButtonIcon = 'close';
  @Input() dialogTitle?: string;
  @Output() dialogClose = new EventEmitter<void>();
}
